import { TrackingEvent } from "@omni/types/components/tracking/trackingEvent.type";
import { TrackingProps } from "@omni/types/components/tracking/trackingProps.type";
import { entries } from "@omni/utils/object.utils";

export const toTrackingEvents = (trackingProps: TrackingProps) => {
    return entries(trackingProps).reduce<TrackingEvent[]>(
        (events, [type, trackingInfo]) => {
            events.push({ type, trackingInfo } as TrackingEvent);

            return events;
        },
        []
    );
};
